import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import axios from "../../utils/axios";
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    InputGroup,
    Badge,
    Input,
    Button,
    Progress,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { FiCircle, FiCheckCircle, FiEdit, FiTrash2, FiEye, FiMoreVertical, FiUpload, FiPlus, FiX } from 'react-icons/fi';
import { FaDotCircle, FaArrowRight, FaArrowLeft } from "react-icons/fa";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useJob } from '../../context/jobContext';

const JobsManagement = (props) => {

    document.title = "Jobs Management | Equity Circle - Admin Dashboard";
    const breadcrumbItems = [
        { title: "Jobs Management", link: "#" },
        { title: "All Jobs", link: "#" },
    ];

    useEffect(() => {
        props.setBreadcrumbItems('Jobs Management', breadcrumbItems);
        fetchJobs();
        fetchCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.setBreadcrumbItems]);

    const fetchCategories = () => {
        axios.get('/api/job-categories')
            .then(response => {
                setCategories(response.data);
            })
            .catch(error => {
                console.error('Error fetching categories:', error);
                toast.error('Failed to fetch job categories');
            });
    };

    const handleAddCategory = (e) => {
        e.preventDefault();
        setCategoryLoading(true);

        axios.post('/api/job-categories', newCategory)
            .then(response => {
                toast.success('Category added successfully');
                fetchCategories();
                setFormData(prev => ({
                    ...prev,
                    category_id: response.data.id
                }));
                setShowCategoryModal(false);
                setNewCategory({ name: '', description: '' });
            })
            .catch(error => {
                console.error('Error adding category:', error);
                toast.error(error.response?.data?.message || 'Failed to add category');
            })
            .finally(() => {
                setCategoryLoading(false);
            });
    };

    // State
    const navigate = useNavigate();
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [newCategory, setNewCategory] = useState({
        name: '',
        description: ''
    });
    const [tagInput, setTagInput] = useState('');
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [perPage] = useState(9);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [jobModal, setJobModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [customSections, setCustomSections] = useState([{ title: '', description: '' }]);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [step, setStep] = useState(1);
    const [isEditMode, setIsEditMode] = useState(false);

    const fileInputRef = useRef(null);

    useEffect(() => {
        if (jobModal) {
            setStep(1); // Reset to first step when modal is opened
        }
    }, [jobModal]);

    // Form state
    const [formData, setFormData] = useState({
        title: '',
        subtitle: '',
        short_description: '',
        min_salary: '',
        max_salary: '',
        currency: '$',
        plus_extra: '',
        job_type: 'Remote',
        job_mode: 'Full Time',
        experience: 'Mid Level',
        country: '',
        location: '',
        lat: '',
        lng: '',
        category_id: '',
        tags: []
    });

    // Fetch jobs with search functionality
    const fetchJobs = async (page = 1, search = '') => {
        try {
            setLoading(true);
            let url = `/api/jobs-crm?page=${page}`;

            if (search) {
                url += `&search=${encodeURIComponent(search)}`;
            }

            const response = await axios.get(url);
            setJobs(response.data.jobs.data);
            setCurrentPage(response.data.jobs.current_page);
            setTotalPages(response.data.jobs.last_page);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching jobs:', error);
            toast.error('Failed to fetch jobs');
            setLoading(false);
        }
    };

    // Handle search input with debounce
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchQuery(value);

        // Clear previous timeout
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Set a new timeout to avoid too many API calls
        setSearchTimeout(
            setTimeout(() => {
                fetchJobs(1, value);
            }, 500)
        );
    };

    // Handle page change
    const handlePageChange = (page) => {
        fetchJobs(page, searchQuery);
    };

    // Toggle modals
    const toggleJobModal = () => setJobModal(!jobModal);
    const toggleViewModal = () => setViewModal(!viewModal);
    const toggleDeleteModal = () => setDeleteModal(!deleteModal);
    const toggleDropdown = (jobId) => {
        setOpenDropdownId(openDropdownId === jobId ? null : jobId);
    };

    // Validate form step
    const validateStep = () => {
        const newErrors = {};

        if (step === 1) {
            if (!formData.title.trim()) newErrors.title = 'Job Title is required';
            if (!formData.subtitle.trim()) newErrors.subtitle = 'Company name is required';
            if (!formData.short_description.trim()) newErrors.short_description = 'Short description is required';
            if (!formData.job_type) newErrors.job_type = 'Job Type is required';
            if (!formData.job_mode) newErrors.job_mode = 'Job Mode is required';
        }

        if (step === 2) {
            // Budget validation
            if (!formData.min_salary) newErrors.min_salary = 'Min Budget is required';
            if (!formData.max_salary) newErrors.max_salary = 'Max Budget is required';
            if (!formData.currency) newErrors.currency = 'Currency is required';

            // Experience validation
            if (!formData.experience) newErrors.experience = 'Experience is required';
            if (!formData.category_id) newErrors.category_id = 'Category is required';
            if (!formData.country.trim()) newErrors.country = 'Country is required';
            if (!formData.location.trim()) newErrors.location = 'Location is required';
        }

        if (step === 3) {
            if (!isEditMode && !imageFile && !imagePreview) {
                newErrors.image = 'Image is required';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'category_id' && value === 'add_new') {
            setShowCategoryModal(true);
            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: ''
            }));
        }
    };

    // Handle tag input change
    const handleTagInputChange = (e) => {
        setTagInput(e.target.value);
    };

    // Handle tag add (on Enter key)
    const handleTagKeyDown = (e) => {
        if (e.key === 'Enter' && tagInput.trim()) {
            const trimmedTag = tagInput.trim();
            if (!formData.tags.includes(trimmedTag)) {
                setFormData(prev => ({
                    ...prev,
                    tags: [...prev.tags, trimmedTag]
                }));
                setTagInput('');
            }
        }
    };

    // Handle tag remove
    const handleTagRemove = (index) => {
        setFormData(prev => ({
            ...prev,
            tags: prev.tags.filter((_, i) => i !== index)
        }));
    };

    // Handle custom section change
    const handleCustomSectionChange = (index, field, value) => {
        const updatedSections = [...customSections];
        updatedSections[index][field] = value;
        setCustomSections(updatedSections);
    };

    // Add custom section
    const addCustomSection = () => {
        const lastSection = customSections[customSections.length - 1];

        // Basic validation: check if title and description are filled
        if (!lastSection.title.trim() || !lastSection.description.trim()) {
            toast.error('Please fill out the title and description before adding a new section.');
            return;
        }

        // If valid, add new section
        setCustomSections([...customSections, { title: '', description: '' }]);
    };

    // Remove custom section
    const removeCustomSection = (index) => {
        if (customSections.length > 1) {
            const updatedSections = [...customSections];
            updatedSections.splice(index, 1);
            setCustomSections(updatedSections);
        }
    };

    // Handle image upload
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Open file dialog
    const openFileDialog = () => {
        fileInputRef.current.click();
    };

    // Reset form
    const resetForm = () => {
        setFormData({
            title: '',
            subtitle: '',
            short_description: '',
            min_salary: '',
            max_salary: '',
            currency: '$',
            plus_extra: '',
            job_type: 'Remote',
            job_mode: 'Full Time',
            experience: 'Mid Level',
            country: '',
            location: '',
            lat: '',
            lng: '',
            category_id: '',
            tags: []
        });
        setCustomSections([{ title: '', description: '' }]);
        setImagePreview(null);
        setImageFile(null);
        setIsEditMode(false);
        setSelectedJob(null);
    };

    // View job details
    const viewJobDetails = (job) => {
        setSelectedJob(job);
        toggleViewModal();
    };

    // Prepare form for editing
    const prepareEditForm = (job) => {
        setSelectedJob(job);
        setIsEditMode(true);

        setFormData({
            title: job.title,
            subtitle: job.subtitle,
            short_description: job.short_description,
            min_salary: job.min_salary,
            max_salary: job.max_salary,
            currency: job.currency,
            plus_extra: job.plus_extra,
            job_type: job.job_type,
            job_mode: job.job_mode,
            experience: job.experience,
            country: job.country,
            location: job.location,
            lat: job.lat,
            lng: job.lng,
            category_id: job.category_id,
            tags: job.tags && Array.isArray(job.tags) ? job.tags.map(tag => tag.name) : []
        });

        setCustomSections(JSON.parse(job.custom_sections));
        setImagePreview(job.main_image_url);
        toggleJobModal();
    };

    // Delete job confirmation
    const confirmDeleteJob = (job) => {
        setSelectedJob(job);
        toggleDeleteModal();
    };

    // Handle next step
    const handleNext = () => {
        if (validateStep()) {
            setStep(step + 1);
        }
    };

    // Handle previous step
    const handlePrevious = () => {
        if (step > 1) {
            setStep(step - 1);
        }
    };

    // Submit job form (create or update)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;

        setIsSubmitting(true);
        try {
            const formDataToSend = new FormData();

            // Append basic fields
            Object.keys(formData).forEach(key => {
                formDataToSend.append(key, formData[key]);
            });

            // Append custom sections
            customSections.forEach((section, index) => {
                formDataToSend.append(`custom_sections[${index}][title]`, section.title);
                formDataToSend.append(`custom_sections[${index}][description]`, section.description);
            });

            // Append tags
            formData.tags.forEach(tag => {
                formDataToSend.append('tags[]', tag);
            });

            // Append image if exists
            if (imageFile) {
                formDataToSend.append('main_image', imageFile);
            }

            let response;
            if (isEditMode) {
                // For edit, use PUT method
                formDataToSend.append('_method', 'PUT');
                response = await axios.post(`/api/jobs/${selectedJob.id}`, formDataToSend, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            } else {
                // For create, use POST
                response = await axios.post('/api/jobs', formDataToSend, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }

            toast.success(response.data.message);
            toggleJobModal();
            resetForm();
            fetchJobs();
        } catch (error) {
            console.error('Error saving job:', error);
            toast.error(error.response?.data?.message || `Failed to ${isEditMode ? 'update' : 'create'} job`);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Open modal for new job
    const openNewJobModal = () => {
        resetForm();
        toggleJobModal();
    };

    // Delete job
    const handleDelete = async () => {
        try {
            await axios.delete(`/api/jobs/${selectedJob.id}`);
            toast.success('Job deleted successfully');
            toggleDeleteModal();
            fetchJobs();
        } catch (error) {
            console.error('Error deleting job:', error);
            toast.error('Failed to delete job');
        }
    };

    // Render pagination
    const renderPagination = () => {
        const items = [];
        for (let i = 1; i <= totalPages; i++) {
            items.push(
                <PaginationItem key={i} active={i === currentPage}>
                    <PaginationLink onClick={() => handlePageChange(i)}>
                        {i}
                    </PaginationLink>
                </PaginationItem>
            );
        }
        return items;
    };

    const { jobContent, updateJobContent } = useJob();

    const handleUpdateClick = (job) => {
        // alert(`
        //     ID: ${job.id}
        //     Name: ${job.title}
        //     SubTitle: ${job.subtitle}
        // `);
        updateJobContent({
            id: job.id,
            job_title: job.title,
            job_subtitle: job.subtitle,
            job_description: job.short_description,
            job_create_date: job.created_at,
            job_currency: job.currency,
            job_mode: job.job_mode,
            job_type: job.job_type,
            job_location: job.location,
            job_min_salery: job.min_salary,
            job_max_salery: job.max_salary,
        });
        navigate('/jobs-management/applications');
    };

    return (
        <div>
            <ToastContainer />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
            >
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex justify-content-between gap-3 align-items-center mb-5">
                                    <h4 className="mb-0">Jobs Management</h4>
                                    <div className="d-flex justify-content-end gap-2 align-items-center">
                                        <div className="position-relative" style={{ maxWidth: '500px', minWidth: '350px', width: '100%' }}>
                                            <Input
                                                type="text"
                                                className="form-control bg-light"
                                                placeholder="Search jobs by title, company, or location..."
                                                value={searchQuery}
                                                onChange={handleSearch}
                                            />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                        <Button color="primary" style={{ minWidth: 'fit-content' }} onClick={openNewJobModal}>
                                            <FiPlus className="mr-1" /> Post a new job
                                        </Button>
                                    </div>
                                </div>

                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Title</th>
                                                    <th>Company</th>
                                                    <th>Applied</th>
                                                    <th>Created By</th>
                                                    <th>Type</th>
                                                    <th>Location</th>
                                                    <th>Salary</th>
                                                    <th>Status</th>
                                                    <th>Created At</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {jobs.map((job, index) => (
                                                    <tr key={index} className="custom-font-family">
                                                        <td>{index + 1}</td>
                                                        <td>{job.title}</td>
                                                        <td>{job.subtitle}</td>
                                                        <td>{job.application_count}</td>
                                                        <td>{job?.user?.name}</td>
                                                        <td>
                                                            <Badge color="info" className="custom-batch">
                                                                {job.job_type} | {job.job_mode}
                                                            </Badge>
                                                        </td>
                                                        <td>{job.location}, {job.country}</td>
                                                        <td>
                                                            {job.currency}{job.min_salary} - {job.currency}{job.max_salary}
                                                            {job.plus_extra && ` + ${job.plus_extra}`}
                                                        </td>
                                                        <td>
                                                            {job.is_active ? (
                                                                <Badge color="success" className="custom-batch">
                                                                    <FiCheckCircle className="mr-1" /> Active
                                                                </Badge>
                                                            ) : (
                                                                <Badge color="secondary" className="custom-batch">
                                                                    <FiCircle className="mr-1" /> Inactive
                                                                </Badge>
                                                            )}
                                                        </td>
                                                        <td>{moment(job.created_at).format('MMM D, YYYY h:mm A')}</td>
                                                        <td>
                                                            <Dropdown isOpen={openDropdownId === job.id} toggle={() => toggleDropdown(job.id)} className="action-dropdown">
                                                                <DropdownToggle tag="a" className="text-dark">
                                                                    <FiMoreVertical />
                                                                </DropdownToggle>
                                                                <DropdownMenu right className="custom-dropdown-menu">
                                                                    {/* <DropdownItem onClick={() => viewJobDetails(job)}>
                                                                        <FiEye className="mr-1" /> View
                                                                    </DropdownItem> */}
                                                                    <DropdownItem onClick={() => prepareEditForm(job)}>
                                                                        <FiEdit className="mr-1" /> Edit
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={() => handleUpdateClick(job)}>
                                                                        <FiEye className="mr-1" /> View All Applications
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={() => confirmDeleteJob(job)} className="text-danger">
                                                                        <FiTrash2 className="mr-1" /> Delete
                                                                    </DropdownItem>
                                                                </DropdownMenu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>

                                        {totalPages > 1 && (
                                            <div className="d-flex justify-content-between gap-2 align-items-center">
                                                <div>
                                                    <p className="mb-0 text-muted">
                                                        Showing {jobs.length} of {totalPages * perPage} entries
                                                    </p>
                                                </div>
                                                <Pagination>
                                                    <PaginationItem disabled={currentPage === 1}>
                                                        <PaginationLink
                                                            previous
                                                            onClick={() => handlePageChange(currentPage - 1)}
                                                        />
                                                    </PaginationItem>
                                                    {renderPagination()}
                                                    <PaginationItem disabled={currentPage === totalPages}>
                                                        <PaginationLink
                                                            next
                                                            onClick={() => handlePageChange(currentPage + 1)}
                                                        />
                                                    </PaginationItem>
                                                </Pagination>
                                            </div>
                                        )}
                                    </>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </motion.div>

            {/* Job Form Modal (used for both create and edit) */}
            <Modal isOpen={jobModal} toggle={toggleJobModal} size="lg" backdrop={false}>
                <ModalHeader toggle={toggleJobModal}>
                    {isEditMode ? 'Edit Job' : 'Add New Job'}
                </ModalHeader>
                <div className="d-flex justify-content-between align-items-center mt-2 position-relative" style={{ height: '80px', width: '100%', margin: '0 auto', marginLeft: '20px' }}>
                    {[
                        { number: 1, title: 'Basic Info' },
                        { number: 2, title: 'Budget & Experience' },
                        { number: 3, title: 'Image' },
                    ].map((item, index, arr) => (
                        <div
                            key={index}
                            className="text-center position-relative flex-fill"
                            style={index === arr.length - 1 ? { width: '18%' } : {}}
                        >
                            {/* Connecting line to next step */}
                            {index !== arr.length - 1 && (
                                <div
                                    className={`position-absolute border-top ${step > item.number ? 'border-success' : 'border-secondary'}`}
                                    style={{
                                        top: '20px',
                                        left: '56%',
                                        width: '100%',
                                        height: '2px',
                                        zIndex: 0,
                                    }}
                                ></div>
                            )}

                            {/* Step Circle */}
                            <div
                                className={`rounded-circle d-flex align-items-center justify-content-center 
                                ${step === item.number
                                        ? 'bg-primary text-white fw-bold'
                                        : step > item.number
                                            ? 'bg-success text-white'
                                            : 'bg-light text-muted'}`}
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    zIndex: 1,
                                    margin: '0 auto',
                                    position: 'relative',
                                }}
                            >
                                {step > item.number ? '✓' : item.number}
                            </div>

                            {/* Step Title */}
                            <div className={step === item.number ? 'fw-bold text-primary' : 'text-muted'}>
                                {item.title}
                            </div>
                        </div>

                    ))}
                </div>

                <Form onSubmit={handleSubmit}>
                    <ModalBody style={{ minHeight: '600px' }}>
                        <Row>
                            {step === 1 && (
                                <>
                                    <Col lg="12">
                                        <FormGroup>
                                            <Label>
                                                Job Title
                                                <span class="text-danger ms-1">*</span>
                                            </Label>
                                            <Input
                                                name="title"
                                                value={formData.title}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.title}
                                            />
                                            {errors.title && <div className="text-danger">{errors.title}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="12">
                                        <FormGroup>
                                            <Label>Company/Organization Name <span class="text-danger ms-1">*</span></Label>
                                            <Input
                                                name="subtitle"
                                                value={formData.subtitle}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.subtitle}
                                            />
                                            {errors.subtitle && <div className="text-danger">{errors.subtitle}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="12">
                                        <FormGroup>
                                            <Label>Short Description <span class="text-danger ms-1">*</span></Label>
                                            <Input
                                                type="textarea"
                                                name="short_description"
                                                value={formData.short_description}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.short_description}
                                            />
                                            {errors.short_description && <div className="text-danger">{errors.short_description}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="12">
    <FormGroup>
        <Label>Tags</Label>
        <div className="d-flex flex-wrap gap-2 align-items-center">
            {formData.tags.map((tag, index) => (
                <Badge
                    key={index}
                    color="primary"
                    className="me-2 mb-2"
                    onClick={() => handleTagRemove(index)}
                    style={{ cursor: 'pointer' }}
                >
                    {tag} <FiX className="ms-1" />
                </Badge>
            ))}
            <Input
                type="text"
                name="tags"
                value={tagInput}
                onChange={handleTagInputChange}
                onKeyDown={handleTagKeyDown}
                placeholder="Add tags (press Enter to add)"
                style={{ minWidth: '200px' }}
            />
        </div>
    </FormGroup>
</Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Job Type <span class="text-danger ms-1">*</span></Label>
                                            <Input
                                                type="select"
                                                name="job_type"
                                                value={formData.job_type}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.job_type}
                                            >
                                                <option>Remote</option>
                                                <option>On-site</option>
                                                <option>Hybrid</option>
                                            </Input>
                                            {errors.job_type && <div className="text-danger">{errors.job_type}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Job Mode <span class="text-danger ms-1">*</span></Label>
                                            <Input
                                                type="select"
                                                name="job_mode"
                                                value={formData.job_mode}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.job_mode}
                                            >
                                                <option>Full Time</option>
                                                <option>Part Time</option>
                                                <option>Contract</option>
                                                <option>Freelance</option>
                                                <option>Internship</option>
                                            </Input>
                                            {errors.job_mode && <div className="text-danger">{errors.job_mode}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="12">
                                        <h5>Custom Sections</h5>
                                        <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '10px' }}>
                                            {customSections.map((section, index) => (
                                                <div key={index} className="border p-3 mb-3 rounded">
                                                    <FormGroup className="d-flex flex-column justify-content-between gap-0">
                                                        <Label>Section Title</Label>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <Input
                                                                value={section.title}
                                                                onChange={(e) => handleCustomSectionChange(index, 'title', e.target.value)}
                                                                className="flex-grow-1"
                                                            />
                                                            {customSections.length > 1 && (
                                                                <Button color="danger" className="flex-shrink-0" onClick={() => removeCustomSection(index)}>
                                                                    <FiTrash2 size={18} />
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label>Description</Label>
                                                        <ReactQuill
                                                            value={section.description}
                                                            onChange={(val) => handleCustomSectionChange(index, 'description', val)}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            ))}
                                            <Button color="primary" onClick={addCustomSection}>Add Section</Button>
                                        </div>
                                    </Col>
                                </>
                            )}

                            {step === 2 && (
                                <>
                                    {/* Budget Section */}
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Min Budget <span className="text-danger ms-1">*</span></Label>
                                            <Input
                                                type="number"
                                                name="min_salary"
                                                value={formData.min_salary}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.min_salary}
                                            />
                                            {errors.min_salary && <div className="text-danger">{errors.min_salary}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Max Budget <span className="text-danger ms-1">*</span></Label>
                                            <Input
                                                type="number"
                                                name="max_salary"
                                                value={formData.max_salary}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.max_salary}
                                            />
                                            {errors.max_salary && <div className="text-danger">{errors.max_salary}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Currency <span className="text-danger ms-1">*</span></Label>
                                            <Input
                                                type="select"
                                                name="currency"
                                                value={formData.currency}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.currency}
                                            >
                                                <option value="$">$</option>
                                                <option value="€">€</option>
                                                <option value="£">£</option>
                                                <option value="¥">¥</option>
                                                <option value="₹">₹</option>
                                            </Input>
                                            {errors.currency && <div className="text-danger">{errors.currency}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Plus Extra</Label>
                                            <Input
                                                name="plus_extra"
                                                value={formData.plus_extra}
                                                onChange={handleInputChange}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* Experience Section */}
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Experience Level <span className="text-danger ms-1">*</span></Label>
                                            <Input
                                                type="select"
                                                name="experience"
                                                value={formData.experience}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.experience}
                                            >
                                                <option>Entry Level</option>
                                                <option>Mid Level</option>
                                                <option>Senior Level</option>
                                                <option>Executive</option>
                                            </Input>
                                            {errors.experience && <div className="text-danger">{errors.experience}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Category <span className="text-danger ms-1">*</span></Label>
                                            <InputGroup>
                                                <Input
                                                    type="select"
                                                    name="category_id"
                                                    value={formData.category_id}
                                                    onChange={handleInputChange}
                                                    required
                                                    invalid={!!errors.category_id}
                                                >
                                                    <option value="">Select a category</option>
                                                    {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                                                    <option value="" disabled>──────────</option>
                                                    <option value="add_new" className="text-primary fw-bold">
                                                        + Add New Category
                                                    </option>
                                                </Input>
                                                <Button
                                                    color="light"
                                                    type="button"
                                                    onClick={() => setShowCategoryModal(true)}
                                                >
                                                    <FiPlus />
                                                </Button>
                                            </InputGroup>
                                            {errors.category_id && <div className="text-danger">{errors.category_id}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Country <span className="text-danger ms-1">*</span></Label>
                                            <Input
                                                name="country"
                                                value={formData.country}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.country}
                                            />
                                            {errors.country && <div className="text-danger">{errors.country}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Location <span className="text-danger ms-1">*</span></Label>
                                            <Input
                                                name="location"
                                                value={formData.location}
                                                onChange={handleInputChange}
                                                required
                                                invalid={!!errors.location}
                                            />
                                            {errors.location && <div className="text-danger">{errors.location}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Latitude</Label>
                                            <Input
                                                name="lat"
                                                value={formData.lat}
                                                onChange={handleInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <Label>Longitude</Label>
                                            <Input
                                                name="lng"
                                                value={formData.lng}
                                                onChange={handleInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </>
                            )}


                            {step === 3 && (
                                <Col lg="12">
                                    <FormGroup>
                                        <Label>Main Image {!isEditMode && <span class="text-danger ms-1">*</span>}</Label>
                                        <div
                                            className={`border rounded p-3 text-center position-relative ${errors.image ? 'border-danger' : 'border-secondary'
                                                }`}
                                            style={{
                                                cursor: 'pointer',
                                                background: '#f8f9fa',
                                                transition: 'border-color 0.3s',
                                            }}
                                            onClick={openFileDialog}
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={(e) => {
                                                e.preventDefault();
                                                const file = e.dataTransfer.files[0];
                                                if (file) handleImageUpload({ target: { files: [file] } });
                                            }}
                                        >
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                onChange={handleImageUpload}
                                                style={{ display: 'none' }}
                                                accept="image/*"
                                            />

                                            {imagePreview ? (
                                                <img
                                                    src={imagePreview}
                                                    alt="Preview"
                                                    className="img-thumbnail"
                                                    style={{ maxHeight: 150 }}
                                                />
                                            ) : (
                                                <div>
                                                    <FiUpload size={32} className="mb-2 text-muted" />
                                                    <p className="mb-0 text-muted">Drag & Drop or Click to Upload</p>
                                                </div>
                                            )}
                                        </div>

                                        {errors.image && (
                                            <div className="text-danger mt-2" style={{ fontSize: '0.9rem' }}>
                                                {errors.image}
                                            </div>
                                        )}
                                        {isEditMode && (
                                            <small className="text-muted">Leave empty to keep current image</small>
                                        )}
                                    </FormGroup>
                                </Col>
                            )}
                        </Row>
                    </ModalBody>

                    <ModalFooter className="d-flex w-100 justify-content-between">
                        {step > 1 ? (
                            <Button color="secondary" onClick={handlePrevious}>
                                <FaArrowLeft className="me-2" />
                                Previous
                            </Button>
                        ) : (
                            <div /> // keeps spacing
                        )}

                        {step < 3 ? (
                            <Button color="primary" onClick={handleNext} >
                                Next <FaArrowRight className="ms-2" />
                            </Button>
                        ) : (
                            <div className="d-flex gap-2">
                                <Button color="secondary" onClick={toggleJobModal}>Cancel</Button>
                                <Button color="success" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Saving...' : isEditMode ? 'Update Job' : 'Save Job'}
                                </Button>
                            </div>
                        )}
                    </ModalFooter>
                </Form>
            </Modal>

            {/* View Job Modal */}
            <Modal isOpen={viewModal} toggle={toggleViewModal} size="lg" backdrop={false}>
                <ModalHeader toggle={toggleViewModal}>Job Details</ModalHeader>
                <ModalBody>
                    {selectedJob && (
                        <div>
                            <Row>
                                <Col lg="12" className="text-center mb-3">
                                    <img
                                        src={selectedJob.main_image_url}
                                        alt={selectedJob.title}
                                        className="img-fluid rounded"
                                        style={{ maxHeight: '200px' }}
                                    />
                                </Col>

                                <Col lg="12">
                                    <h3>{selectedJob.title}</h3>
                                    <h5 className="text-muted">{selectedJob.subtitle}</h5>
                                    <p className="text-muted">
                                        <FaDotCircle className="mr-1" />
                                        {selectedJob.location}, {selectedJob.country} | {selectedJob.job_type} | {selectedJob.job_mode}
                                    </p>

                                    <div className="my-3">
                                        <h5>Salary</h5>
                                        <p>
                                            {selectedJob.currency}{selectedJob.min_salary} - {selectedJob.currency}{selectedJob.max_salary}
                                            {selectedJob.plus_extra && ` + ${selectedJob.plus_extra}`}
                                        </p>
                                    </div>

                                    <div className="my-3">
                                        <h5>Experience Level</h5>
                                        <p>{selectedJob.experience}</p>
                                    </div>

                                    <div className="my-3">
                                        <h5>Short Description</h5>
                                        <p>{selectedJob.short_description}</p>
                                    </div>

                                    {selectedJob.custom_sections && JSON.parse(selectedJob.custom_sections).map((section, index) => (
                                        <div key={index} className="my-3">
                                            <h5>{section.title}</h5>
                                            <div dangerouslySetInnerHTML={{ __html: section.description }} />
                                        </div>
                                    ))}

                                    <div className="mt-4">
                                        <small className="text-muted">
                                            Posted on: {moment(selectedJob.created_at).format('MMMM D, YYYY')}
                                        </small>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleViewModal}>Close</Button>
                </ModalFooter>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModal} toggle={toggleDeleteModal} backdrop={false}>
                <ModalHeader toggle={toggleDeleteModal}>Confirm Delete</ModalHeader>
                <ModalBody>
                    {selectedJob && (
                        <p>Are you sure you want to delete the job <strong>"{selectedJob.title}"</strong>? This action cannot be undone.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleDeleteModal}>Cancel</Button>
                    <Button color="danger" onClick={handleDelete}>Delete</Button>
                </ModalFooter>
            </Modal>

            {/* Add Category Modal */}
            <Modal isOpen={showCategoryModal} toggle={() => setShowCategoryModal(false)} backdrop={false}>
                <ModalHeader toggle={() => setShowCategoryModal(false)}>
                    Add New Job Category
                </ModalHeader>
                <Form onSubmit={handleAddCategory}>
                    <ModalBody>
                        <FormGroup>
                            <Label>Category Name *</Label>
                            <Input
                                type="text"
                                value={newCategory.name}
                                onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Description</Label>
                            <Input
                                type="textarea"
                                value={newCategory.description}
                                onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => setShowCategoryModal(false)}
                            disabled={categoryLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            type="submit"
                            disabled={categoryLoading || !newCategory.name.trim()}
                        >
                            {categoryLoading ? 'Adding...' : 'Add Category'}
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </div>
    );
};

export default connect(null, { setBreadcrumbItems })(JobsManagement);